@let navMenuId = 'main-nav';

<div id="header-scroll-effect-marker"></div>
@if (headerMode() && headerMode() !== 'none') {
    <header
        id="page-header"
        class="p-24:t p-24:b"
        [ngClass]="{ '-detached': detached }"
    >
        <div class="header-container content-container">
            <div
                class="grid-container -bottom-v -spread-content"
                [ngClass]="{
                    '-bottom-v': headerMode() === 'default',
                    '-center-v': headerMode() !== 'default',
                }"
            >
                <div class="g-auto">
                    <a
                        [routerLink]="['/']"
                        (click)="closeAllNavMenus()"
                    >
                        <img
                            src="/assets/icons/logo_astra_versicherung.svg"
                            alt="astra Versicherung AG"
                            id="logo"
                        />
                    </a>
                </div>

                <!-- #region default header mode -->
                @if (headerMode() === 'default') {
                    <nav
                        class="g-auto"
                        (clickOutside)="closeAllNavMenus()"
                    >
                        <a
                            [routerLink]="['portal', 'dashboard']"
                            class="button -ghost login-small fs:xs"
                            aria-label="Anmelden"
                        ></a>
                        <button
                            id="drop"
                            #hamburgerButton
                            (click)="toggleMainNavMenuOpen()"
                            [attr.aria-label]="isMainNavMenuOpen() ? 'Navigation anzeigen' : 'Navigation schließen'"
                            [attr.aria-expanded]="isMainNavMenuOpen()"
                            [attr.aria-controls]="navMenuId"
                        >
                            <div class="nav-toggle">
                                <img
                                    src="/assets/icons/icon_menu_blue.svg"
                                    alt=""
                                    role="presentation"
                                />
                            </div>
                        </button>

                        <ul
                            [id]="navMenuId"
                            tabindex="-1"
                        >
                            @for (linkGroup of navigation; track $index; let i = $index) {
                                <li
                                    class="main-nav-top-level"
                                    [ngClass]="{ open: linkGroup.open }"
                                >
                                    <a
                                        [id]="getNavigationId(i)"
                                        (click)="closeAllNavMenus()"
                                        (keydown)="onNavigationKeydown($event, linkGroup, i)"
                                        [routerLink]="linkGroup.rootLink"
                                        aria-haspopup="true"
                                        [attr.aria-expanded]="linkGroup.open"
                                        [attr.aria-controls]="getMenuId($index)"
                                        [inert]="isAnySubNavOpen()"
                                    >
                                        {{ linkGroup.description }}
                                    </a>
                                    @if (linkGroup.links.length > 0) {
                                        <button
                                            [id]="'drop-' + i"
                                            class="subnav-toggle float-right"
                                            (click)="toggleSubNavMenuOpen(i)"
                                            aria-label="Untermenü öffnen"
                                            [attr.aria-description]="linkGroup.description"
                                            [attr.aria-expanded]="isSubNavMenuOpen()[i]"
                                            [attr.aria-controls]="getMenuId(i)"
                                            [inert]="isAnySubNavOpen()"
                                        ></button>
                                        <ul
                                            [id]="getMenuId(i)"
                                            class="sub-nav"
                                            role="menu"
                                            [inert]="!isSubNavMenuOpen()[i] && isMainNavMenuOpen()"
                                        >
                                            <li>
                                                <button
                                                    class="toggle-back"
                                                    (click)="toggleSubNavMenuOpen(i)"
                                                >
                                                    Zurück
                                                </button>
                                            </li>
                                            @for (link of linkGroup.links; track $index; let subi = $index) {
                                                <li>
                                                    <a
                                                        [id]="getNavigationItemId(i, subi)"
                                                        [title]="link.title"
                                                        [routerLink]="link.routerLink"
                                                        (click)="closeAllNavMenus()"
                                                        (keydown)="onNavigationItemKeydown($event, linkGroup, i, subi)"
                                                        class="nav-link"
                                                        role="menuitem"
                                                    >
                                                        {{ link.description }}
                                                    </a>
                                                </li>
                                            }
                                        </ul>
                                    }
                                </li>
                            }
                            <li class="login">
                                <a
                                    [routerLink]="['portal', 'dashboard']"
                                    class="button login-large"
                                    aria-label="Anmelden"
                                >
                                    <i ctrlIcon="person"></i>
                                    {{ isLoggedIn ? 'Portal' : 'Login' }}
                                </a>
                            </li>
                        </ul>
                    </nav>
                }
                <!-- #endregion -->
            </div>
        </div>
    </header>
}
